/* The Aesthetic Cove — the name in the hero headline.
   "Christmas, with ___ name on it." A laser point runs along the gap and a
   name appears behind it in gold script, the way the studio engraves one.
   It holds, lifts away, and the next name is written. The names come from
   the hero's "Names the laser writes" setting.

   Starts when the intro lifts, rests while the hero is off screen or the tab
   is hidden, and does nothing for visitors who prefer reduced motion (they
   keep the word "their"). */
(() => {
  const el = document.querySelector('[data-hero-names]');
  const ink = el && el.querySelector('[data-name-ink]');
  if (!ink) return;
  const names = (el.dataset.heroNames || '')
    .split(',')
    .map((s) => s.trim())
    .filter(Boolean);
  if (!names.length || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  const WRITE = 1150; // the laser's run, matched in section-hero-video.css
  const HOLD = 2700;
  const LIFT = 420;
  let i = 0;
  let timer = 0;
  let onScreen = true;
  let started = false;

  const restart = (cls) => {
    el.classList.remove(cls);
    void el.offsetWidth;
    el.classList.add(cls);
  };
  const write = () => {
    clearTimeout(timer);
    if (!onScreen || document.hidden) return;
    ink.textContent = names[i % names.length];
    el.classList.remove('is-lifting');
    restart('is-writing');
    timer = setTimeout(() => {
      el.classList.add('is-lifting');
      timer = setTimeout(() => {
        i += 1;
        write();
      }, LIFT);
    }, WRITE + HOLD);
  };
  const start = () => {
    if (started) return;
    started = true;
    el.classList.add('is-live');
    write();
  };

  if ('IntersectionObserver' in window) {
    new IntersectionObserver(([entry]) => {
      const was = onScreen;
      onScreen = entry.isIntersecting;
      if (started && onScreen && !was) write();
      if (!onScreen) clearTimeout(timer);
    }).observe(el);
  }
  document.addEventListener('visibilitychange', () => {
    if (!started) return;
    if (document.hidden) clearTimeout(timer);
    else write();
  });

  // Write the first name once the page is up: after the intro, if there is one.
  const go = () => {
    const fonts = document.fonts && document.fonts.load ? document.fonts.load('1em Parisienne') : Promise.resolve();
    Promise.race([fonts, new Promise((r) => setTimeout(r, 1200))]).then(() => setTimeout(start, 650));
  };
  if (document.documentElement.classList.contains('intro-active')) {
    window.addEventListener('intro:done', go, { once: true });
    setTimeout(go, 12000);
  } else {
    go();
  }
})();
